import React from 'react';
import { useTranslation } from '../lib/i18n';
export function PrivacyPolicyPage() {
  const {
    lang
  } = useTranslation();
  const en = lang === 'en';
  const ru = lang === 'ru';
  return <main className="min-h-screen bg-dark-bg pt-24 pb-16" data-id="element-884">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-885">
        <h1 className="text-3xl md:text-4xl font-black text-white mb-8" data-id="element-886">
          {en ? 'Privacy Policy' : ru ? 'Политика конфиденциальности' : 'Politika privatnosti'}
        </h1>
        <div className="prose prose-invert max-w-none text-gray-300 space-y-6" data-id="element-887">
          <p data-id="element-888">
            Ova Politika privatnosti opisuje kako DTECH ATLAS DOO (u daljem
            tekstu "mi", "naš", "D-TECH") prikuplja, koristi i štiti vaše lične
            podatke kada posetite naš sajt dtech.rs ili koristite naše usluge.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-889">
            1. Podaci koje prikupljamo
          </h2>
          <p data-id="element-890">
            Prikupljamo podatke koje nam dobrovoljno dostavite putem kontakt
            formi, formi za upit ili prilikom komunikacije putem e-maila i
            telefona. To može uključivati vaše ime, e-mail adresu, broj telefona
            i naziv kompanije.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-891">
            2. Kako koristimo vaše podatke
          </h2>
          <p data-id="element-892">Vaše podatke koristimo isključivo u svrhu:</p>
          <ul className="list-disc pl-5 space-y-2" data-id="element-893">
            <li data-id="element-894">
              Odgovaranja na vaše upite i pružanja informacija o našim
              proizvodima.
            </li>
            <li data-id="element-895">Obrade vaših porudžbina i organizacije isporuke.</li>
            <li data-id="element-896">Pružanja tehničke podrške i servisa.</li>
            <li data-id="element-897">Unapređenja naših usluga i korisničkog iskustva na sajtu.</li>
          </ul>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-898">
            3. Zaštita podataka
          </h2>
          <p data-id="element-899">
            Primenjujemo odgovarajuće tehničke i organizacione mere kako bismo
            zaštitili vaše lične podatke od neovlašćenog pristupa, gubitka ili
            zloupotrebe. Vaši podaci se čuvaju u sigurnom okruženju i dostupni
            su samo ovlašćenim zaposlenima.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-900">
            4. Deljenje podataka sa trećim licima
          </h2>
          <p data-id="element-901">
            Vaše lične podatke ne prodajemo, ne iznajmljujemo i ne delimo sa
            trećim licima u marketinške svrhe. Podatke možemo podeliti sa
            pouzdanim partnerima (npr. kurirske službe) isključivo u svrhu
            realizacije isporuke ili servisa.
          </p>

          <h2 className="text-xl font-bold text-white mt-8" data-id="element-902">5. Vaša prava</h2>
          <p data-id="element-903">
            Imate pravo da zatražite uvid u podatke koje imamo o vama, kao i
            njihovu ispravku ili brisanje. Za sva pitanja u vezi sa zaštitom
            podataka, možete nas kontaktirati na info@dtech.rs.
          </p>
        </div>
      </div>
    </main>;
}